import React, { ReactNode } from "react";
import { cn } from "@/libs/utils";
import { Subtitle1 } from "@/components/webview/games/typograpy/typograpy-webview";

export const LayoutGamesWebView = ({
  header,
  contents,
  className,
}: {
  header?: ReactNode;
  contents: ReactNode;
  className?: string;
}) => {
  return (
    <section
      className={cn("flex flex-col gap-6 text-[20px] font-500", className)}
    >
      {header && <Subtitle1>{header}</Subtitle1>}
      {contents}
    </section>
  );
};
